import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./App.css";
import { UserLoginPage } from "./user/UserLoginPage";
import AdminRoutes from "./admin/adminRoutes";
import NotFound from "./admin/components/404page";
import CustomerRoutes from "./customers/customerRoutes";
import DemoRoutes from "./demo/demoRoutes";
import { Provider } from "react-redux";
import createStore from "./store";
import { ConnectNewInboxPage } from "./user/ConnectNewInboxPage";
import { AdminAuthSuccess } from "./user/AdminAuthSuccess";
import { FeedbackFormPage } from "./user/feedback/FeedbackFormPage";
import DesktopWidgetRoutes from "./desktopWidget/desktopWidgetRoutes";
import { ShipmentsPageWrapper } from "./shipments/ShipmentsPage";
import { ExceptionsDashboard } from "./shipments/reminders/ExceptionsDashboard";
import { SnackbarProvider } from "./components/SnackbarProvider";
const { store } = createStore();

const GOOGLE_CLIENT_ID =
  "457685302907-5ngb3vb0ign0fkt4pvsp2b58gnh77unh.apps.googleusercontent.com";

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <SnackbarProvider>
        <BrowserRouter basename="/www">
          <Provider store={store}>
            <Routes>
              {/* Public Routes (No Redux) */}
              <Route
                path="/user"
                element={<div className="App">WWW Dobby!</div>}
              />
              <Route path="/user/login" element={<UserLoginPage />} />
              <Route path="/user/admin_login" element={<AdminAuthSuccess />} />
              <Route
                path="/user/connect_inbox"
                element={<ConnectNewInboxPage />}
              />
              <Route
                path="/user/feedback/form"
                element={<FeedbackFormPage />}
              />

              {/* Customer routes */}
              <Route path="/user/customer/*" element={<CustomerRoutes />} />

              {/* Shipments routes */}
              <Route path="/shipments" element={<ShipmentsPageWrapper />} />
              <Route
                path="/shipments/reminders-dashboard"
                element={<ExceptionsDashboard />}
              />

              {/* Admin routes */}
              <Route path="/admin/*" element={<AdminRoutes />} />

              {/* Desktop Widget */}
              <Route
                path="/desktop_widget/*"
                element={<DesktopWidgetRoutes />}
              />

              {/* Demo routes */}
              <Route path="/demo/*" element={<DemoRoutes />} />

              {/* Catch-all 404 Page */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Provider>
        </BrowserRouter>
      </SnackbarProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
